import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import './gallery.css';


import Graduationimg1 from '../../assets/grad1.jpg';
import Graduationimg2 from '../../assets/grad2.jpg';
import Graduationimg3 from '../../assets/grad3.jpg';
import Graduationimg4 from '../../assets/grad8.jpg';
import Graduationimg5 from '../../assets/grad5.jpg';
import Graduationimg6 from '../../assets/grad6.jpg';
import Graduationimg7 from '../../assets/grad7.jpg';
import Graduationimg8 from '../../assets/grad9.jpg';
import Graduationimg9 from '../../assets/grad10.jpg';
import Graduationimg10 from '../../assets/grad11.jpg';
import Graduationimg11 from '../../assets/grad12.jpg'
import Graduationimg12 from '../../assets/pub1.jpg';
import Graduationimg13 from '../../assets/pub2.jpg';
import Graduationimg14 from '../../assets/pub3.jpg';
import Graduationimg15 from '../../assets/pub4.jpg';
import Graduationimg16 from '../../assets/pub5.jpg';
import Graduationimg17 from '../../assets/pub6.jpg';
import Graduationimg18 from '../../assets/com100.jpg'
import Graduationimg19 from '../../assets/com101.jpg';
import Graduationimg20 from '../../assets/com102.jpg';
import Graduationimg21 from '../../assets/com103.jpg';
import Graduationimg22 from '../../assets/com104.jpg';
import Graduationimg23 from '../../assets/com105.jpg';
import Graduationimg24 from '../../assets/com106.jpg';


// import Graduationimg13 from '../../assets/grad13.jpg';
// import Graduationimg14 from '../../assets/grad14.jpg';
// import Graduationimg15 from '../../assets/grad15.jpg';
// import Graduationimg16 from '../../assets/grad16.jpg';
// import Graduationimg17 from '../../assets/grad17.jpg';
// import Graduationimg18 from '../../assets/grad18.jpg';

import Programimg2 from '../../assets/aware1.jpg';

import Programimg4 from '../../assets/aware3.jpg';
import Programimg5 from '../../assets/aware4.jpg';
import Programimg6 from '../../assets/aware5.jpg';
import Programimg7 from '../../assets/aware6.jpg';
import Programimg8 from '../../assets/aware7.jpg';
import Programimg9 from '../../assets/aware8.jpg';
import Programimg10 from '../../assets/aware9.jpg';
import Programimg11 from '../../assets/aware10.jpg';
import Programimg12 from '../../assets/aware11.jpg';
import Programimg13 from '../../assets/aware12.jpg';
import Programimg14 from '../../assets/aware13.jpg';
import Programimg15 from '../../assets/aware14.jpg';
import Programimg16 from '../../assets/aware15.jpg';
import Programimg17 from '../../assets/aware16.jpg';
import Programimg3 from '../../assets/aware17.jpg';



import programimg18 from '../../assets/aware18.jpg';
import programimg19 from '../../assets/aware19.jpg';    
import programimg20 from '../../assets/aware20.jpg';


import Communityimg1 from '../../assets/moh1.jpg';
import Communityimg2 from '../../assets/moh2.jpg';
import Communityimg3 from '../../assets/moh3.jpg';
import Communityimg4 from '../../assets/moh4.jpg';
import Communityimg5 from '../../assets/moh5.jpg';
import Communityimg6 from '../../assets/moh6.jpg';
import Communityimg7 from '../../assets/moh7.jpg';
import Communityimg8 from '../../assets/moh8.jpg';
import Communityimg9 from '../../assets/moh9.jpg';
import Communityimg10 from '../../assets/moh10.jpg';
import Communityimg11 from '../../assets/moh11.jpg';
import Communityimg12 from '../../assets/moh12.jpg';



// import EyeCampimg1 from '../../assets/eyecamp1.jpg';
// import EyeCampimg2 from '../../assets/eyecamp2.jpg';
// import EyeCampimg3 from '../../assets/eyecamp3.jpg';
// import EyeCampimg4 from '../../assets/eyecamp4.jpg';
// import EyeCampimg5 from '../../assets/eyecamp5.jpg';
// import EyeCampimg6 from '../../assets/eyecamp6.jpg';
// import EyeCampimg7 from '../../assets/eyecamp7.jpg';
// import EyeCampimg8 from '../../assets/eyecamp8.jpg';
// import EyeCampimg10 from '../../assets/eyecamp10.jpg';
// import EyeCampimg11 from '../../assets/eyecamp11.jpg';
// import EyeCampimg12 from '../../assets/eyecamp12.jpg';
// import EyeCampimg13 from '../../assets/eyecamp1.jpg';



const sections = [
  {
    title: 'Colombo Public Library',
    images: [Graduationimg1, Graduationimg2, Graduationimg3, Graduationimg4, Graduationimg5, Graduationimg6, Graduationimg7, Graduationimg8, Graduationimg9, Graduationimg10, Graduationimg11, Graduationimg12,  Graduationimg13, Graduationimg14, Graduationimg15, Graduationimg16, Graduationimg17, Graduationimg18, Graduationimg19, Graduationimg20, Graduationimg21, Graduationimg22, Graduationimg23, Graduationimg24],
    
  },


  {
    title: 'Training & policy development programme with PHI & MOH',
    images: [ Programimg2, Programimg4, Programimg5, Programimg6,  Programimg7, Programimg8, Programimg9, programimg18, programimg19, programimg20, Programimg10, Programimg11, Programimg12, Programimg13, Programimg14, Programimg15, Programimg16, Programimg17, Programimg3, ],
  },


//   {
//     title: 'Eye Checkup Camps',
//     images: [EyeCampimg1, EyeCampimg2, EyeCampimg3, EyeCampimg4, EyeCampimg5, EyeCampimg6, EyeCampimg7, EyeCampimg8, EyeCampimg10, EyeCampimg11, EyeCampimg12, EyeCampimg13 ],
//   },



  {
    title: 'Eye Examination at MOH Office',
    images: [Communityimg1, Communityimg2, Communityimg3, Communityimg4, Communityimg5, Communityimg6, Communityimg7, Communityimg8,  Communityimg9, Communityimg10, Communityimg11, Communityimg12],
  },

];

const Gallery = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">

<div className='two-section-word-container'>
  <h1 className='reach-unreach'>
    <span className='green-text'>REACHING TO</span>
    <span className='yellow-text'>UNREACH</span>
  </h1>
</div>

      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};

export default Gallery;
